"use strict";

define('service/loading',['appkit/service', 'nprogress', 'uikit/modules/dimmer', 'uikit/collections/container', 'uikit/modules/loader', 'uikit/elements/button', 'uikit/views/error'], function (Service, NProgress, Dimmer, ContainerView, Loader, ButtonView, ErrorView) {
  var LoadingService = Service.extend({
    events: {
      'resize:menu': 'resizeDimmer',
      'page:state:created': 'setupPageState'
    },
    replies: {
      'dimmer': 'showDimmer',
      'setupDimmer': 'setupDimmer',
      'build:page:dimmer': 'buildPageDimmer'
    },
    inject: ['legacyApp', 'legacyLayout', 'layout'],
    initialize: function initialize() {
      this.dimmer = this.buildPageDimmer();
      this.legacyDimmer = this.buildPageDimmer();
      NProgress.configure({
        showSpinner: false,
        parent: '.common-header',
        template: '<div class="bar" role="bar"><div class="peg"></div></div><div class="nprogress-loading"></div><div class="spinner" role="spinner"><div class="spinner-icon"></div></div>'
      });
    },
    buildPageDimmer: function buildPageDimmer(options) {
      options = _.extend({
        loader: true
      }, options);
      return new Dimmer({
        inverted: true,
        page: true,
        centered: true,
        active: false,
        content: options.loader ? new Loader({
          size: 'large',
          active: true
        }) : null
      });
    },
    onInjectionComplete: function onInjectionComplete() {
      if (this.channel.request('legacy:enabled')) {
        this.legacyLayout.dimmer.show(this.legacyDimmer);
      }
      this.layout.dimmer.show(this.dimmer);
    },
    setupPageState: function setupPageState(state) {
      var done = this.showDimmer({
        delay: true,
        hideLoader: true
      });
      NProgress.set(.15);
      NProgress.start();
      this.listenToOnce(state, 'page:loaded', function () {
        done();
        NProgress.done(true);
        this.layout.$el.find('.nprogress-loading').addClass('done');
        this.layout.$el.find('.common-header').removeClass('nprogress-custom-parent');
      });
    },
    showDimmer: function showDimmer(options) {
      var dimmer = this.dimmer,
        doDimmer = true;
      options = _.extend({}, options);
      if (options.legacy) {
        dimmer = this.legacyDimmer;
      }
      if (options.hideLoader) {
        dimmer.$el.find('div.ui.loader').css({
          visibility: 'hidden'
        });
      } else {
        dimmer.$el.find('div.ui.loader').css({
          visibility: 'visible'
        });
      }
      if (options.delay) {
        setTimeout(function () {
          if (doDimmer) {
            dimmer.active = true;
          }
        }, 400);
      } else {
        dimmer.active = true;
      }
      return function () {
        doDimmer = false;
        setTimeout(function () {
          dimmer.active = false;
        }, 400);
      };
    },
    resizeDimmer: function resizeDimmer(ev) {
      if (!this.dimmer) {
        return;
      }
      this.dimmer.$el.css('padding-left', ev.left);
      this.legacyDimmer.$el.css('padding-left', ev.left);
    },
    buildDimmerContent: function buildDimmerContent() {
      var content = new ContainerView(),
        loader = new Loader({
          active: false
        }),
        button = new ButtonView({
          text: 'Retry',
          visible: false,
          color: 'red',
          inverted: true,
          icon: 'refresh'
        });
      content.add(loader);
      content.loader = loader;
      return content;
    },
    bindLoaderAndDimmerToLoaderHelper: function bindLoaderAndDimmerToLoaderHelper(dimmer, loader, loaderHelper) {
      loaderHelper.on('change:loading', function () {
        var hasError = !!loaderHelper.get('error');
        if (loaderHelper.get('loading')) {
          loaderHelper.set('error', false);
          dimmer.active = true;
          loader.active = true;
        } else if (!hasError) {
          dimmer.active = false;
          loader.active = false;
        } else {
          loader.active = false;
        }
      });
      return this;
    },
    setupDimmer: function setupDimmer(dimmer, loaderHelper) {
      var content = this.buildDimmerContent();
      dimmer.content = content;
      this.bindLoaderAndDimmerToLoaderHelper(dimmer, content.loader, loaderHelper);
      return dimmer;
    }
  });
  return LoadingService;
});

